const acts = [
    {"value":"Host a quiz for your family"},
    {"value":"Weed the garden in a suit" }, 
    {"value":"Stick googly eyes on candles" }, 
    {"value":"Learn how to juggle" }, 
    {"value":"Play Pandemic (the board game)" }, 
    {"value":"Make a fort from a tissue box" }, 
    {"value":"Set a challenge on Instagram" }, 
    {"value":"Start a YouTube channel about a celebrity you admire" }, 
    {"value":"Plan a safari theme day." }, 
    {"value":"Perform a dance for your family" }, 
    
    

]

export default acts;